import * as Raven from 'raven-js';
import * as React from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import {
  Alert,
  Avatar,
  Container,
  Grid,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  PageTitle,
  SectionHeader,
  SectionHeaderIcon,
  SectionHeaderText,
  SubmitButton,
  Typography,
  withStyles
} from '../../../ui';
import { BancontactIcon, CreditCardIcon, IdealIcon, PayPalIcon } from '../../../ui/Icon/AppIcons';
import { Track } from '../../analytics';
import * as Api from '../../Api';
import { basketSelectors, paymentActions, paymentSelectors } from '../../redux';
import * as Routes from '../../Routes';
import { paymentApiServices } from '../../services';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import RouterBackLink from '../RouterBackLink';
import { MainLayout } from '../MainLayout/MainLayout';
import FlipDishCopyRight from '../FlipDishCopyRight/index.weborder';

const SofortIcon = require('../../assets/images/sofort.svg');
const GiropayIcon = require('../../assets/images/giropay.svg');
const EpsIcon = require('../../assets/images/eps.svg');
const AlipayIcon = require('../../assets/images/alipay.svg');
const MultibancoIcon = require('../../assets/images/multibanco.svg');
const P24Icon = require('../../assets/images/p24.svg');

const isDev = process.env.NODE_ENV === 'development';
const isHttps = window.location.protocol === 'https:';

const ListWithBorders = withStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    '& > li': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-child': {
        borderBottom: 'none'
      }
    }
  }
}))(List);
// 😔 this not working coz of jss-plugins... TODO FIGURE OUT WHICH PLUGIN MESSING THINGS UP
// styled(List)(({ theme }) => ({
//   border: `1px solid gray`
// }));

const DarkThemeAvatar = withStyles((theme) => ({
  root: {
    ...(theme.palette.type === 'light'
      ? {
          backgroundColor: 'transparent'
        }
      : {})
  }
}))(Avatar);

//#region
// TODO similar thing from checkout...
type ParsePaymentProps = {
  payment: WebOrder.State.Payment;
  translate: ReturnType<typeof getTranslate>;
};
function parsePayment({ payment, translate }: ParsePaymentProps) {
  let text: string = payment.Description;
  let icon: React.ReactElement = null;
  let fdKey: string = `payment-delete-${payment.paymentId}`;

  switch (payment.PaymentAccountType) {
    case Api.GatewayPaymentAccount.Bancontact: {
      text = payment.Description;
      icon = <BancontactIcon height={27} width={27} aria-hidden />;
      break;
    }

    case 'BrainTreePayPalPaymentAccount': {
      icon = <PayPalIcon height={27} aria-hidden />;
      text = `PayPal (${payment.Description.slice(payment.Description.indexOf(' '))})`;
      break;
    }

    case 'CardPaymentAccount': {
      icon = <CreditCardIcon color="action" />;
      const cardNumber = payment.Description.slice(payment.Description.indexOf('*'));
      text = `${translate('Card')} ${cardNumber || ''}`;
      break;
    }

    case Api.GatewayPaymentAccount.Ideal: {
      text = payment.Description;
      icon = <IdealIcon height={27} aria-hidden />;
      break;
    }

    //#region TODO check how it looks? do we really support this??
    case Api.GatewayPaymentAccount.Alipay:
      text = payment.Description;
      icon = <img className="payment__method__icon" src={AlipayIcon} aria-hidden="true" alt="" />;
      break;
    case Api.GatewayPaymentAccount.Eps:
      text = payment.Description;
      icon = <img className="payment__method__icon" src={EpsIcon} aria-hidden="true" alt="" />;
      break;
    case Api.GatewayPaymentAccount.Giropay:
      text = payment.Description;
      icon = <img className="payment__method__icon" src={GiropayIcon} aria-hidden="true" alt="" />;
      break;
    case Api.GatewayPaymentAccount.Multibanco:
      text = payment.Description;
      icon = (
        <img className="payment__method__icon" src={MultibancoIcon} aria-hidden="true" alt="" />
      );
      break;
    case Api.GatewayPaymentAccount.P24:
      text = payment.Description;
      icon = <img className="payment__method__icon" src={P24Icon} aria-hidden="true" alt="" />;
      break;
    case Api.GatewayPaymentAccount.Sofort:
      text = payment.Description;
      icon = <img className="payment__method__icon" src={SofortIcon} aria-hidden="true" alt="" />;
    //#region

    default:
      text = translate(payment.Description, undefined, {
        missingTranslationMsg: payment.Description
      }) as string;
      break;
  }

  return {
    text,
    icon,
    fdKey
  };
}

type PaymentListItemProps = {
  payment: WebOrder.State.Payment;
  disabled: boolean;
  translate: ReturnType<typeof getTranslate>;
  onClick(paymentId: number);
};
const PaymentListItem = React.memo((props: PaymentListItemProps) => {
  const { payment, disabled, translate, onClick } = props;
  const { text, icon, fdKey } = parsePayment({ payment, translate });

  return (
    <ListItem>
      <ListItemAvatar>
        <DarkThemeAvatar>{icon}</DarkThemeAvatar>
      </ListItemAvatar>

      <ListItemText disableTypography>
        <Typography variant="body1" color="textPrimary">
          {text}
        </Typography>
      </ListItemText>

      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          data-fd={fdKey}
          aria-label={`${translate('Delete_payment_method')} ${text}`}
          onClick={() => {
            onClick(payment.PaymentAccountId);
          }}
        >
          <Icon className="ei icon_trash_alt" fontSize="inherit" color="primary" aria-hidden />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
});
//#endregion

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface State {
  Error: string;
}

type Props = StateProps & DispatchProps & Routes.Routes;

class Payment extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);
    this.state = {
      Error: ''
    };
  }

  private addCard = (): any => {
    Track('Payments', 'Add New Card Begin');
    Utilities.navigateTo(`/card/${encodeURIComponent(window.location.hash)}`);
  };

  // TODO BL should move to saga
  private handleDelete = (paymentAccountId: number) => {
    const { AppConfig, Customer } = this.props;

    paymentApiServices
      .remove({ paymentAccountId })
      .then(() => {
        this.props.paymentRemoved({ paymentId: `${paymentAccountId}` });
        Track('Payments', 'Remove Card');
      })
      .catch((error) => {
        let appconfig: any = {};
        let customer: any = {};

        if (AppConfig.status === 'success') {
          appconfig.AppNameId = AppConfig.data.AppNameId;
          appconfig.WhiteLabelId = AppConfig.data.WhiteLabelId;
        }

        if (Customer.status === 'success') {
          customer.CustomerName = Customer.data.CustomerName;
          customer.EmailAddress = Customer.data.EmailAddress;
        }

        Raven.captureMessage('Error deleting payment method', {
          tags: { category: 'API failure' },
          extra: {
            error: Utilities.handleError(error),
            appconfig: appconfig,
            customer: customer,
            paymentAccountId: paymentAccountId
          }
        });
        let message: string = 'There was an error deleting the payment method';

        try {
          message = error.response.data.UserMessage;
        } catch (error) {
          // Be brave of fallback.
        }

        this.setState({
          Error: message
        });
      });
  };

  public render() {
    const { params, translate, payments } = this.props;

    return (
      <MainLayout xsPaddingBottom="60px">
        <Container maxWidth="lg">
          <PageTitle>{translate('Payment')}</PageTitle>

          <RouterBackLink to={`/restaurant/${params.vrid}/${params.type}/${params.id}`}>
            {translate('Back')}
          </RouterBackLink>

          <SectionHeader>
            <SectionHeaderIcon>
              <CreditCardIcon color="primary" fontSize="large" />
            </SectionHeaderIcon>

            <SectionHeaderText title={translate('Payment_methods') as string} />
          </SectionHeader>

          <Grid container justify="center" spacing={3}>
            <Grid item xs={12}>
              {payments.length > 0 && (
                <ListWithBorders disablePadding>
                  {payments.map((p) => (
                    <PaymentListItem
                      key={p.paymentId}
                      payment={p}
                      disabled={false}
                      translate={translate}
                      onClick={this.handleDelete}
                    />
                  ))}
                </ListWithBorders>
              )}
            </Grid>

            {!!this.state.Error && (
              <Grid item xs={12}>
                <Alert color="error" align="center">
                  {this.state.Error}
                </Alert>
              </Grid>
            )}

            {!isHttps && (
              <Grid item xs={12}>
                <Alert color="warning" align="center" aria-live="polite">
                  {this.props.translate('Cards_cannot_added')}
                </Alert>
              </Grid>
            )}
            <Grid item xs={12}>
              <FlipDishCopyRight />
            </Grid>
            <Grid item sm={4}>
              <SubmitButton
                // TODO should be Link
                dataFd="payment-add-card"
                type="button"
                disabled={!isHttps && !isDev}
                onClick={this.addCard}
              >
                {translate('Add_card')}
              </SubmitButton>
            </Grid>
          </Grid>
        </Container>
      </MainLayout>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    paymentRemoved: (payload: { paymentId: string }) => {
      dispatch(paymentActions.paymentRemoved(payload));
    }
  };
};

const mapStateToProps = (state: Store.State, ownProps: Routes.Routes) => {
  let payments = paymentSelectors.getRemovablePayments(state);
  const restaurant = basketSelectors.getRestaurantDetails(state);

  // WHY THIS, WHY???
  if (restaurant && restaurant.AcceptCardOrders === false) {
    payments = payments.filter((p) => p.PaymentAccountType !== 'CardPaymentAccount');
  }

  return {
    AppConfig: state.flipdish.AppConfig,
    Customer: state.flipdish.Customer,
    payments,
    translate: getTranslate(state.locale)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
